const getFormerSuggestions = (store) => {
	return store.Session?.formerSuggestions || {};
};

export const getFormerSuggestionByKey = (dbKey) => (store) => {
	return store.Session?.formerSuggestions[dbKey]?.data || [];
};

export default getFormerSuggestions;
